export const APPLICANTS_MAX = 9;

export const ATTACHMENT_IDS = Object.freeze({
  adoptionPapers: 'Court ordered adoption papers',
  birthCert: 'Birth certificate',
  civilUnionCert: 'Civil union papers',
  divorceDecree: 'Divorce decree',
  driversLicense: 'Driver\u2019s license',
  marriageCert: 'Marriage certificate',
  medicareAbCardFront: 'Front of Medicare Parts A or B card',
  medicareAbCardBack: 'Back of Medicare Parts A or B card',
  medicareCCardFront: 'Front of Medicare Part C card',
  medicareCCardBack: 'Back of Medicare Part C card',
  medicareDCardFront: 'Front of Medicare Part D card',
  medicareDCardBack: 'Back of Medicare Part D card',
  ohiCardFront: 'Front of health insurance card',
  ohiCardBack: 'Back of health insurance card',
  passport: 'Passport',
  schoolCertificationForm: 'School enrollment certification form',
  schoolEnrollmentLetter: 'Enrollment letter',
  socialSecurityCard: 'Social Security card',
  ssaLetter: 'Letter from the SSA',
});

export const ENROLLMENT_STATUS_KEY = 'view:enrollmentStatus';

export const ENROLLMENT_STATUSES = Object.freeze({
  enrolled: 'enrolled',
  notEnrolled: 'not_enrolled',
  notFound: 'not_found',
  vesError: 'ves_error',
});

export const NOT_ENROLLED_STATUSES = new Set([
  ENROLLMENT_STATUSES.notEnrolled,
  ENROLLMENT_STATUSES.notFound,
]);

export const FILE_SIZE_MAX_MB = 20;
export const FILE_SIZE_MAX_BYTES = 1024 * 1024 * FILE_SIZE_MAX_MB;
export const FILE_TYPES_ACCEPTED = ['.heic', '.jpeg', '.jpg', '.pdf', '.png'];

export const OHI_ITEM_MAX = 2;

export const FORM_KEYS = Object.freeze({
  prefillEnabled: 'view:form1010dPrefillEnabled',
  enrollmentCheck: 'view:champvaEnrollmentStatusCheck',
});

export const FORM_TOGGLES = [
  {
    toggleName: 'form1010dPrefillEnabled',
    formKey: FORM_KEYS.prefillEnabled,
  },
  {
    toggleName: 'champvaEnrollmentStatusCheck',
    formKey: FORM_KEYS.enrollmentCheck,
  },
];
